import React from 'react';
import * as T from 'prop-types';
import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import {
    getAddressFieldLabelsByCountry,
    getAddressFieldPlaceholdersByCountry,
} from '../../../commons/CountryUtils';
import { validateAndRequiredZipCodeUtil } from '../../../commons/utils';
import { ADDRESS_PLACEHOLDER } from '../../../commons/Constants';

const AddressInfoFormSection = (props) => {
    const labels = getAddressFieldLabelsByCountry(props.consultantCountry);
    const placeholders = getAddressFieldPlaceholdersByCountry(
        props.consultantCountry
    );
    return (
        <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
            <HeaderAndError label="Address" />
            <GenericTextInputField
                name="info.address.addressLine"
                label="Address Line"
                placeholder={ADDRESS_PLACEHOLDER}
                type="text"
                required
            />
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="info.address.city"
                        label={labels.city}
                        placeholder={placeholders.city}
                        type="text"
                        required
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="info.address.state"
                        label={labels.state}
                        placeholder={placeholders.state}
                        type="text"
                        required
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericSelectInputField
                        name="info.address.country"
                        label="Country"
                        initialValue={props.consultantCountry}
                        // TODO - when you add more countries to dropdown, remove initialValue to correctly reflect country
                        // value from draft, because initialValue at field level takes preference over initialValues at Form level.
                        options={[
                            {
                                key: props.consultantCountry,
                                value: props.consultantCountry,
                                label: labels.name,
                            },
                        ]}
                        required
                        disabled
                    />
                </div>
            </div>
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="info.address.zipcode"
                        label={labels.zipCode}
                        placeholder={placeholders.zipCode}
                        type="text"
                        validateAndRequiredZipCodeUtil={(val) =>
                            validateAndRequiredZipCodeUtil(
                                val,
                                props.consultantCountry
                            )
                        }
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericSelectInputField
                        name="info.address.addressType"
                        label="Address Type"
                        options={[
                            { key: 'Work', label: 'Work', value: 'Work' },
                            { key: 'Home', label: 'Home', value: 'Home' },
                        ]}
                        required
                    />
                </div>
            </div>
        </div>
    );
};

AddressInfoFormSection.propTypes = {
    consultantCountry: T.string,
};

export default AddressInfoFormSection;
